function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
import get from 'lodash/get';
import { mapState, mapGetters } from 'vuex';
export default {
  props: {
    side: {
      type: String,
      required: true
    }
  },
  computed: _objectSpread({}, mapState({
    elements: function elements(s) {
      return s.elements;
    }
  }), {}, mapGetters({
    isPresent: 'elements/at',
    resultType: 'api/formResultType'
  }), {
    fields: function fields() {
      return this.$ncsConfig.result[this.resultType].elements.tokens.fields;
    },
    elementsLength: function elementsLength() {
      return this.elements[this.side].length;
    },
    maxElements: function maxElements() {
      return get(this.$ncsConfig.result[this.resultType], 'elements.maximum', 0);
    }
  }),
  methods: {
    addElement: function addElement(i) {
      this.$store.commit('elements/addElement', {
        side: this.side,
        fields: this.fields,
        index: i
      });
    },
    removeElement: function removeElement(i) {
      this.$store.commit('elements/removeElement', {
        side: this.side,
        index: i
      });
    }
  }
};